import { mdiEye } from '@mdi/js'
import Icon from '@mdi/react'

const Eye = (props) => (
    <Icon
        data-testid="IconButton__EyeButton"
        aria-label="Show Password"
        path={mdiEye}
        size={1}
        {...props}
    />
)

export default Eye
